export default "__VITE_ASSET__BBvcaYBH__"